import React from "react"
import dynamic from "next/dynamic"
import noimage from "../../../../images/noImage.png"
import Button from "../../../objects/Button/Button"
import SiteWrapper from "../../../structure/SiteWrapper/SiteWrapper"
import ReadMore from "../../global/ReadMore/ReadMore"
import LandingPageSuppliers from "../LandingPageSuppliers/LandingPageSuppliers"
import * as styles from "./LandingPageHeader.module.scss"

const LandingPageServices = dynamic(() => import("../LandingPageServices/LandingPageServices"), { ssr: false })

const LandingPageHeader = (props) => {
  const isLargeGrid =
    (props.featured === "services" && props.partyServicePages?.length > 9) ||
    (props.featured === "suppliers" && props.suppliers?.length > 9)

  const getFeature = () => {
    switch (props.featured) {
      case "services":
        if (props.partyServicePages.length) {
          return (
            <div className={styles.services}>
              <LandingPageServices layout="grid" partyServicePages={props.partyServicePages} />
            </div>
          )
        }
        return (
          <div className={styles.image}>
            <img
              src={props.featuredImage ? props.featuredImage.url + "?fm=jpg&fit=crop&w=800&h=700" : noimage}
              alt=""
            />
          </div>
        )
      case "suppliers":
        return (
          <div className={styles.suppliers}>
            <LandingPageSuppliers
              layout="grid"
              service={props.service.id}
              category={props.category}
              suppliers={props.suppliers}
            />
          </div>
        )
      default:
        return null
    }
  }

  return (
    <section className={`${styles.LandingPageHeader} ${styles[props.featured]}`}>
      <SiteWrapper>
        <div className={styles.grid}>
          <div className={`${styles.introWrapper} ${isLargeGrid ? styles.large : ""}`}>
            <div className={styles.intro}>
              <div className={styles.text}>
                <h1>{props.title}</h1>
                <ReadMore text={props.intro} />
                <Button
                  className={styles.cta}
                  color="pink"
                  design="outline"
                  text={props.ctaText}
                  link={`/suppliers-search/?category=${props.category}${
                    props.service ? '&services=["' + props.service.id + '"]' : ""
                  }`}
                />
              </div>
            </div>
          </div>
          <div className={styles.featured}>{getFeature()}</div>
        </div>
      </SiteWrapper>
    </section>
  )
}

export default LandingPageHeader
